import FetchRequest from "@/api/FetchRequest";
class translationApi {
    // 基础url
    static url = "/ai/translation/";
    // 翻译
    static getTranstlate(text:string,to:string): Promise<any> {
        return FetchRequest.post(this.url + 'ai' +'?text='+text+'&to='+to,"",true );
    }
   
}
export default translationApi;